export default __webpack_public_path__ + "static/media/27_tag_bbq-garden.89c47f7c.svg";